export const SEPARATE_COUNTRY_CODE_PHONE_NUMBER =
    /^(\+\d+(?:\s+\d+)*)\s+(\d+)$/;
export const PLUS_AND_SPACES = /[+\s]/g;
